// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1TMfc","copyright":"footer_copyright__3RrDT","logo":"footer_logo__3ycwr"};